import React from 'react';
import InlineLoader from "v4/components/ui/InlineLoader/InlineLoader";
import MainHeaderNavigationItem
    from 'v4/features/front/navigation/components/MainHeaderNavigation/MainHeaderNavigationItem';
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";

export default function MainHeaderNavigation() {
    const { mainNavigation, isLoading, isError } = useNavigation();

    if (isError) return null;

    if (isLoading) return <InlineLoader className="is-white"/>;

    return mainNavigation
        .filter(item => item.label)
        .map(item => <MainHeaderNavigationItem key={item.native_identifier ?? item.metadata?.id ?? item.slug ?? item.url} item={item}/>)
    ;
}
